import React, { useState, useEffect, useContext } from "react";
import { Parser } from 'html-to-react'
import ModelContext from "../ModelContext";
import Typography from "@mui/material/Typography";
import ReactPlayer from 'react-player'

export const VideoIntro = (props) => {
    const modelCtx = useContext(ModelContext);
    const workingFolder = modelCtx.modelsData[0].workingFolder;
    const videoPath = "/videos/" + workingFolder + "/intro.mp4";

    return (
        <>
            <Typography component="div" className="video-intro" sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}>
                <ReactPlayer
                    url={videoPath}
                    controls={false}
                    playing={true}
                    muted={true}
                    loop={true}
                    width="100%"
                    height="100%"
                />
            </Typography>
            <Typography component="div" className="video-intro" sx={{ flexGrow: 1, display: { xs: 'block', sm: 'none' } }}>
                {Parser().parse('<p>&nbsp;</p>')}
            </Typography>
        </>
    );
};

export default VideoIntro;
